<template>
  <div class="built-final">

    <div class="summary-image" ref="summary">
      <div class="row">
        <div class="col-xs-6">
          <div class="tile-image">
            <div class="tile-inner">
              <img class="image" :src="colorImage" @load="toImage">
              <div class="markers">
                <span v-for="color in colors" :key="color.vector" :style="markerStyle(color)">{{color.index}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-2">
          <div class="colors">
            <div class="row">
              <div class="col-sm-12" v-for="color in uniqueColors" :key="color.index">
                <span class="color" :style="{backgroundColor: color.color}"><span>{{color.index}}</span> {{color.name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-4">
          <div class="layout-image-container">
            <img class="layout-image img-responsive" :src="layoutImage" @load="toImage">
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
        <div class="row">
          <div class="col-sm-6">
            <div class="intro">{{ formtxt }}</div>
          </div>
          <div class="col-sm-6">
            <RequestForm></RequestForm>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import RequestForm from './RequestForm.vue';

export default {
    name: 'TileSubmit',
    components: {
        RequestForm
    },
    props: [
        'formtxt'
    ],
    data: function(){

        return {

        }

    },
    computed: {
        colorImage() {
            return this.$store.state.colorImage;
        },
        layoutImage() {
            return this.$store.state.layoutImage;
        },
        colors() {
            return this.$store.state.colors;
        },
        uniqueColors(){
            let colors = this.colors,
                unique = {};

            for(let key in colors){

                if(!unique[colors[key].index]){
                    unique[colors[key].index] = colors[key];
                }

            }

            return unique;
        }
    },
    methods: {
        toImage(){
            let vm = this,
                image = vm.$refs.summary,
                ratio = image.offsetHeight / image.offsetWidth,
                width = 1200,
                height = width * ratio,
                scale = width / image.offsetWidth,
                config = {
                  width: width,
                  height: height,
                  style: {
                      'transform': 'scale('+scale+')',
                      'transform-origin': 'top left'
                  }
              };

            this.$domtoimage.toBlob(image, config)
                .then(function(dataUrl){
                    vm.$store.commit('setImage', dataUrl);
                });
        },
        markerStyle(color){

            return {left: (color.x * 100) + '%', top: (color.y * 100) + '%'}

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .intro{
    padding-bottom: 15px;
  }

  .tile-image{
    /*padding-top: 19px;*/
    /*padding-left: 34px;*/

    .tile-inner{
      position: relative;
    }

    .image{
      display: block;
      width: 100%;
    }

    .markers{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      pointer-events: none;

      span{
        position: absolute;
        display: block;
        width: 19px;
        height: 19px;
        border-radius: 25px;
        border: 2px solid #000;
        /*padding-top: 2px;*/
        color: #000;
        margin-left: -36px;
        margin-top: -21px;
        font-size: 12px;
        font-weight: bold;
        background-color: #fff;
        text-align: center;
        line-height: 15px;

        &:before {
          content: '';
          display: block;
          position: absolute;
          top: 7px;
          left: 17px;
          height: 2px;
          width: 7px;
          background-color: #000;
        }

        &:after{
          content: '';
          display: block;
          position: absolute;
          top: 12px;
          left: 22px;
          height: 2px;
          width: 15px;
          background-color: #000;
          -ms-transform: rotate(40deg); /* IE 9 */
          -webkit-transform: rotate(40deg); /* Safari */
          transform: rotate(40deg);
        }
      }

    }

  }

  .colors > .row{
    margin-left: -4px;
    margin-right: -4px;

    & > div{
      padding-left: 4px;
      padding-right: 4px;
    }
  }

  .color{
    padding: 10px 10px 0 5px;
    display: block;
    font-size: 12px;
    color: #fff;
    margin-bottom: 2px;
  }

  .summary-image{
    padding: 19px 34px;
  }

  .tc-form{
    margin-top: 25px;
  }

  .form-section{
    margin-top: 50px;
    padding: 25px;
    background-color: #ececec;
  }
</style>
